import { TranslationFunctionType } from '@/common/types';
import { object, string } from 'yup';

export const emailTemplateSchema = (t: TranslationFunctionType) =>
  object({
    name: string().required(t('error.requiredField')),
    subject: string().max(190, t('error.subject.length', { length: 190 })),
    text: string().nullable(),
  });
